import React from 'react'
import { useAuth } from 'context/auth'
import AuthRoutes from './auth-routes'
import AdminRoutes from './admin-routes'
import InvalidAccessRoutes from './unauthorize-routes'
import ChangePassRequiredRoutes from './change-pass-req-routes'
import { ROLES } from 'enums/user'
import AppRoutes from './app-routes'

const Routes = () => {
  const { currentUser } = useAuth()
  const currentRoutes = AppRoutes
  const routes = []

  // PUBLIC
  if (!currentUser) {
    currentRoutes[0].children = routes.concat(AuthRoutes)
    return currentRoutes
  }

  const validUserRole = [ROLES.OPERATOR]

  console.log('CURRENT USER', currentUser)

  // PREMISSION DENIED
  if (
    currentUser &&
    !currentUser.roles.some((role) => validUserRole.includes(role))
  ) {
    currentRoutes[0].children = routes.concat(InvalidAccessRoutes)
    return currentRoutes
  }

  // CHANGE PASSWORD REQUIRED
  if (currentUser && currentUser.change_pass_required) {
    currentRoutes[0].children = routes.concat(ChangePassRequiredRoutes)
    return currentRoutes
  }

  if (currentUser) {
    // ADMIN
    currentRoutes[0].children = routes.concat(AdminRoutes())
    return currentRoutes
  }

  return currentRoutes
}

export default Routes
